// extracted by mini-css-extract-plugin
export default {"chart":"globalViewDonut_chart__B77nA"};